import { render, staticRenderFns } from "./wjt-radio.vue?vue&type=template&id=7df16598&scoped=true"
import script from "./wjt-radio.vue?vue&type=script&lang=js"
export * from "./wjt-radio.vue?vue&type=script&lang=js"
import style0 from "./wjt-radio.vue?vue&type=style&index=0&id=7df16598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df16598",
  null
  
)

export default component.exports